import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./style.scss";

class Challenge extends Component {
  state = {};

  render() {
    return (
      <div className="challenge_home">
        <img
          alt="logo"
          className="challenge_home-logo"
          src={require("../../assets/images/logo.svg")}
        ></img>
        <div className="challenge_home-header">Challenge your friends!</div>
        <div className="challenge_home-body">
          After you choose 1 - 3 friends, you will play the game and your score
          is the one they have to beat.
          <br />
          <br />
          <br /> They have 24h to play the challenge.
          <br />
          <br />
          <br />
          <br />
          <br /> For every win you get 1 point, and so does your friends.
          <br />
          <br />
          <br />
          You can see your stats on the Challenge Chart. <br />
          <br />
          <br />
          <br />
          <strong>Ready?</strong>
          <br />
          <br />
        </div>
        <Link to="/challenge/select">
          <button className="challenge_home-footer">CHALLENGE FRIENDS</button>
        </Link>
      </div>
    );
  }
}

export default Challenge;
